var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobFlaireShip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 706.65 706.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#14635b;}.cls-2{fill:#283331;}.cls-3{fill:#1c7f78;}.cls-4{fill:aqua;}.cls-5{fill:#ff88a4;}.cls-6{fill:#003834;}.cls-7{fill:#0f4c45;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "603.3 425.91 561.46 432.2 474.4 432.2 474.4 358.09 603.3 377.45 603.3 425.91"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "620.68 297.91 3.32 417.29 535.69 417.2 620.68 297.91"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "529.5 431.52 45.67 427.66 3.32 417.29 532.99 416.6 529.5 431.52"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "423.63 465.07 199.51 453.97 199.51 441.26 423.63 430.15 423.63 465.07"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "608.3 471.3 399.31 467.47 315.1 416.25 536.44 416.25 608.3 471.3"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "620.68 297.91 703.32 224.77 529.27 242.29 3.32 417.29 489.44 352.7 620.68 297.91 620.68 297.91"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "616.16 481.87 433.49 478.45 398.74 466.89 607.7 471.3 616.16 481.87"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "114.64 417.67 3.32 417.29 458.45 343.71 620.68 297.91 529.42 378.69 114.64 417.67"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "391.48 320.86 3.32 417.29 102.64 361.7 529.42 241.76 391.48 320.86"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobFlaireShip);
export default __webpack_public_path__ + "static/media/mob-flaire-ship.c25f7303acf08275ea655342e01cc31a.svg";
export { ForwardRef as ReactComponent };